import { apiFetch } from '../../services/api';
import { describeApiError } from '../../utils/apiErrors';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';
const SEARCH_ERROR = 'Не удалось выполнить поиск. Повторите попытку.';

const getHeaders = () => {
    const token = localStorage.getItem('token');
    const branchId = localStorage.getItem('selectedBranchId');
    return {
        ...(branchId && { 'X-Branch-ID': branchId }),
        ...(token && { Authorization: `Bearer ${token}` }),
    };
};

export const searchAll = async (query) => {
    const response = await apiFetch(
        `${API_BASE_URL}/search/?q=${encodeURIComponent(query)}`,
        { headers: getHeaders() }
    );
    const data = await response.json().catch(() => null);
    if (!response.ok) {
        const error = new Error(typeof data?.detail === 'string' ? data.detail : SEARCH_ERROR);
        error.status = response.status;
        throw error;
    }
    if (!data) {
        throw new Error(SEARCH_ERROR);
    }
    return data;
};

export const describeSearchError = (error) => (
    error?.isNetworkError ? error.message : describeApiError(error, SEARCH_ERROR)
);
